import {Directive} from '../directive.interface';
import {TooltipNode} from './model/tooltip-node.model';
import {GlossaryService} from '../glossary/glossary.service';
import {GlossaryRecord} from '../glossary/model/glossary-record.model';
import {TooltipDomInjector} from './tooltip-dom-injector';
import {TooltipConfig} from './config/tooltip-config.interface';
import {tooltipDefaultConfig} from './config/tooltip-default.config';
import {tap, Subject} from 'rxjs';

export class Tooltip implements Directive {
    bootstrapped = false;
    tooltipNodeMap: Map<HTMLElement, TooltipNode> = new Map();

    private config: TooltipConfig = tooltipDefaultConfig;

    openStream = new Subject<TooltipNode>();

    constructor(
        private window: Window,
        private document: Document,
        private glossary: GlossaryService,
        config: TooltipConfig = null
    ) {
        this.config = {...this.config, ...config};
    }

    init(): void {
    }

    injectDom(hostElements: HTMLElement[]): void {
        for (const hostElement of hostElements) {
            const tooltipNode = new TooltipNode(hostElement.getAttribute(this.config.glossaryIdAttribute));
            tooltipNode.initializer = this.glossary.get(tooltipNode.id).pipe(
                tap((glossaryRecord: GlossaryRecord) => tooltipNode.content = glossaryRecord.description)
            );
            tooltipNode.domInjector = new TooltipDomInjector(this.document, hostElement, this, tooltipNode);
            this.tooltipNodeMap.set(hostElement, tooltipNode);
        }
    }

    extendDom(hostElements: HTMLElement[]): void {
        this.injectDom(hostElements.filter((hostElement: HTMLElement) => !this.tooltipNodeMap.has(hostElement)));
    }
}